'use client';

import { Skeleton } from '@mantine/core';

interface StoreCardSkeletonProps {
  /** Number of placeholder rows to render. Defaults to 4, which fits both
   *  the mobile (3 visible) and desktop (5 visible) panel heights. */
  rows?: number;
}

/**
 * Loading placeholder for a single Bopis store card. Mirrors the row chrome
 * in `StoreDetails.tsx` (~95 px tall: px-4 py-3 + 3 inner rows) so the list
 * doesn't shift when real data lands (CLS = 0).
 *
 * 3 Mantine <Skeleton animate /> bars per row:
 *   - top   (h-5, w-2/5)   → radio + label
 *   - mid   (h-3, w-3/5)   → address
 *   - bot   (h-4 + h-6)    → phone text + map icon
 */
const StoreCardSkeletonRow = () => (
  <div className="border-b border-solid border-[#C8C8C8] px-4 py-3">
    <Skeleton height={20} width="40%" radius="sm" />
    <Skeleton height={12} width="60%" radius="sm" mt={8} />
    <div className="mt-3 flex items-center justify-between">
      <Skeleton height={16} width="50%" radius="sm" />
      <Skeleton height={24} width={24} radius="sm" />
    </div>
  </div>
);

const StoreCardSkeleton = ({ rows = 4 }: StoreCardSkeletonProps) => (
  <div aria-label="Loading stores" role="status">
    {Array.from({ length: rows }).map((_, i) => (
      <StoreCardSkeletonRow key={i} />
    ))}
  </div>
);

export default StoreCardSkeleton;
